import { render } from "./SospensioniERiattivazioni.vue?vue&type=template&id=5a4d1621&scoped=true"
import script from "./SospensioniERiattivazioni.vue?vue&type=script&lang=js"
export * from "./SospensioniERiattivazioni.vue?vue&type=script&lang=js"

import "./SospensioniERiattivazioni.vue?vue&type=style&index=0&id=5a4d1621&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4d1621"]])

export default __exports__